import apisauce from 'apisauce';

export default (token) => {
    const api = apisauce.create({
        baseURL: `${process.env.REACT_APP_API}/db`,
        headers: {
            'Content-Type': 'application/json',
            'x-access-token': `${token}`
        },
        responseType: 'json'
    });

    const downloadApi = apisauce.create({
        baseURL: `${process.env.REACT_APP_API}/db`,
        headers: {
            'Content-Type': 'application/json',
            'x-access-token': `${token}`
        },
        responseType: 'arraybuffer'
    });

    const fetchDbList = () => api.get('fetchDbList');
    const fetchSettings = () => api.get('fetchSettings');
    const saveSettings = (settings) => api.put('saveSettings', settings);
    const fetchBranches = () => api.get('fetchBranches');
    const fetchRegions = () => api.get('fetchRegions');
    const createBranch = (branchData) => api.put('createBranch', branchData);
    const updateBranch = (branchData) => api.put('updateBranch', branchData);
    const deleteBranch = (branchData) => api.put('deleteBranch', branchData);
    const fetchBranchFestivals = (branchData) => api.get('fetchBranchFestivals', branchData);
    const fetchFestivals = () => api.get('fetchFestivals');
    const updateBranchFestival = (saveData) => api.put('updateBranchFestival', saveData);
    const addBranchFestival = (saveData) => api.post('addBranchFestival', saveData);
    const deleteBranchFestival = (deleteData) => api.put('deleteBranchFestival', deleteData);
    const fetchBranchFinancialYears = () => api.get('fetchBranchFinancialYears');
    const updateBranchFinancialYear = (saveData) => api.put('updateBranchFinancialYear', saveData);
    const addBranchFinancialYear = (saveData) => api.post('addBranchFinancialYear', saveData);
    const deleteBranchFinancialYear = (deleteData) => api.put('deleteBranchFinancialYear', deleteData);
    const updateBranchTreasure = (branchData) => api.put('updateBranchTreasure', branchData);
    const updateBranchAuditor = (branchData) => api.put('updateBranchAuditor', branchData);
    const fetchUserRules = () => api.get('fetchUserRules');
    const updateBranchUserRules = (data) => api.put('updateBranchUserRules', data);
    const fetchBankAccounts = () => api.get('fetchBankAccounts');
    const deleteBranchBankAccount = (deleteData) => api.put('deleteBranchBankAccount', deleteData);
    const addBranchBankAccount = (saveData) => api.post('addBranchBankAccount', saveData);
    const updateBranchBankAccount = (saveData) => api.put('updateBranchBankAccount', saveData);
    const fetchUsers = () => api.get('fetchUsers');
    const createUser = (userData) => api.put('createUser', userData);
    const updateUser = (userData) => api.put('updateUser', userData);
    const deleteUser = (userData) => api.put('deleteUser', userData);
    const sendEmail = (emailData) => api.post('sendEmail', emailData);
    const createUserRule = (userRuleData) => api.put('createUserRule', userRuleData);
    const updateUserRule = (userRuleData) => api.put('updateUserRule', userRuleData);
    const deleteUserRule = (userRuleData) => api.put('deleteUserRule', userRuleData);
    const fetchFundTypes = () => api.get('fetchFundTypes');
    const deleteFundType = (deleteData) => api.put('deleteFundType', deleteData);
    const createFundType = (saveData) => api.post('createFundType', saveData);
    const updateFundType = (saveData) => api.put('updateFundType', saveData);
    const fetchFundSections = () => api.get('fetchFundSections');
    const deleteFundSection = (deleteData) => api.put('deleteFundSection', deleteData);
    const createFundSection = (saveData) => api.post('createFundSection', saveData);
    const updateFundSection = (saveData) => api.put('updateFundSection', saveData);
    const fetchBalanceSheetOpeningBalances = () => api.get('fetchBalanceSheetOpeningBalances');
    const deleteBalanceSheetOpeningBalance = (deleteData) => api.put('deleteBalanceSheetOpeningBalance', deleteData);
    const createBalanceSheetOpeningBalance = (saveData) => api.post('createBalanceSheetOpeningBalance', saveData);
    const updateBalanceSheetOpeningBalance = (saveData) => api.put('updateBalanceSheetOpeningBalance', saveData);
    const fetchBankReconciliationBalances = () => api.get('fetchBankReconciliationBalances');
    const deleteBankReconciliationBalance = (deleteData) => api.put('deleteBankReconciliationBalance', deleteData);
    const createBankReconciliationBalance = (saveData) => api.post('createBankReconciliationBalance', saveData);
    const updateBankReconciliationBalance = (saveData) => api.put('updateBankReconciliationBalance', saveData);
    const fetchAnalysisCodes = () => api.get('fetchAnalysisCodes');
    const deleteAnalysisCode = (deleteData) => api.put('deleteAnalysisCode', deleteData);
    const createAnalysisCode = (saveData) => api.post('createAnalysisCode', saveData);
    const updateAnalysisCode = (saveData) => api.put('updateAnalysisCode', saveData);
    const fetchMessages = () => api.get('fetchMessages');
    const deleteMessage = (deleteData) => api.put('deleteMessage', deleteData);
    const deleteExpiredMessages = () => api.put('deleteExpiredMessages');
    const createMessage = (saveData) => api.post('createMessage', saveData);
    const updateMessage = (saveData) => api.put('updateMessage', saveData);
    const fetchMessageLinks = () => api.get('fetchMessageLinks');
    const deleteMessageLink = (deleteData) => api.put('deleteMessageLink', deleteData);
    const createMessageLink = (saveData) => api.post('createMessageLink', saveData);
    const updateMessageLink = (saveData) => api.put('updateMessageLink', saveData);
    const fetchAuditLogs = () => api.get('fetchAuditLogs');
    const copyYear = (saveData) => api.post('copyYear', saveData);
    const fetchAccountCategories = () => api.get('fetchAccountCategories');
    const deleteAccountCategory = (deleteData) => api.put('deleteAccountCategory', deleteData);
    const createAccountCategory = (saveData) => api.post('createAccountCategory', saveData);
    const updateAccountCategory = (saveData) => api.put('updateAccountCategory', saveData);
    const fetchVATCodes = () => api.get('fetchVATCodes');
    const deleteVATCode = (deleteData) => api.put('deleteVATCode', deleteData);
    const createVATCode = (saveData) => api.post('createVATCode', saveData);
    const updateVATCode = (saveData) => api.put('updateVATCode', saveData);
    const deleteRegion = (deleteData) => api.put('deleteRegion', deleteData);
    const createRegion = (saveData) => api.post('createRegion', saveData);
    const updateRegion = (saveData) => api.put('updateRegion', saveData);
    const fetchFinancialYears = () => api.get('fetchFinancialYears');
    const deleteFinancialYear = (deleteData) => api.put('deleteFinancialYear', deleteData);
    const createFinancialYear = (saveData) => api.post('createFinancialYear', saveData);
    const updateFinancialYear = (saveData) => api.put('updateFinancialYear', saveData);

    const downloadBranchSummary = (details) => downloadApi.get('downloadBranchSummary', details);
    const downloadBankAccountBalances = (details) => downloadApi.get('downloadBankAccountBalances', details);
    const downloadOverDueYearEndFiling = () => downloadApi.get('downloadOverDueYearEndFiling');
    const downloadYearEndSignOff = (details) => downloadApi.get('downloadYearEndSignOff', details);

    const uploadApi = apisauce.create({
        baseURL: `${process.env.REACT_APP_API}/db`,
        headers: {
            'x-access-token': `${token}`
            // No Content-Type here — browser sets it automatically with boundary for multipart
        },
        responseType: 'json'
    });

    const uploadLogo = (branchCommitteeCode, file) => {
        const formData = new FormData();
        formData.append('logo', file);
        formData.append('branchCommitteeCode', branchCommitteeCode);
        return uploadApi.post('uploadLogo', formData);
    };

    const removeLogo = (branchCommitteeCode) =>
        api.post('removeLogo', { branchCommitteeCode });

    const uploadFestivalLogo = (festivalKey, file) => {
        const formData = new FormData();
        formData.append('logo', file);
        formData.append('RecordType', festivalKey.RecordType);
        formData.append('BranchCommitteeCode', festivalKey.BranchCommitteeCode);
        formData.append('DivisionCode', festivalKey.DivisionCode);
        formData.append('RestrictedFundCode', festivalKey.RestrictedFundCode);
        return uploadApi.post('uploadFestivalLogo', formData);
    };

    const removeFestivalLogo = (festivalKey) =>
        api.post('removeFestivalLogo', festivalKey);
    
    const unlockUser = (userData) => api.post('unlockUser', userData);
    const checkUserLocked = (userData) => api.put('checkUserLocked', userData);
    const resetUser = (userData) => api.post('resetUser', userData);
    const checkUserReset = (userData) => api.put('checkUserReset', userData);

    return {
        fetchDbList,
        fetchSettings,
        saveSettings,
        fetchBranches,
        fetchRegions,
        updateBranch,
        createBranch,
        deleteBranch,
        fetchBranchFestivals,
        fetchFestivals,
        updateBranchFestival,
        addBranchFestival,
        deleteBranchFestival,
        fetchBranchFinancialYears,
        updateBranchFinancialYear,
        addBranchFinancialYear,
        deleteBranchFinancialYear,
        updateBranchTreasure,
        updateBranchAuditor,
        fetchUserRules,
        updateBranchUserRules,
        fetchBankAccounts,
        deleteBranchBankAccount,
        addBranchBankAccount,
        updateBranchBankAccount,
        fetchUsers,
        updateUser,
        createUser,
        deleteUser,
        sendEmail,
        updateUserRule,
        createUserRule,
        deleteUserRule,
        fetchFundTypes,
        deleteFundType,
        createFundType,
        updateFundType,
        fetchFundSections,
        deleteFundSection,
        createFundSection,
        updateFundSection,
        fetchBalanceSheetOpeningBalances,
        deleteBalanceSheetOpeningBalance,
        createBalanceSheetOpeningBalance,
        updateBalanceSheetOpeningBalance,
        fetchBankReconciliationBalances,
        deleteBankReconciliationBalance,
        createBankReconciliationBalance,
        updateBankReconciliationBalance,
        fetchAnalysisCodes,
        deleteAnalysisCode,
        createAnalysisCode,
        updateAnalysisCode,
        fetchMessages,
        deleteMessage,
        deleteExpiredMessages,
        createMessage,
        updateMessage,
        fetchMessageLinks,
        deleteMessageLink,
        createMessageLink,
        updateMessageLink,
        fetchAuditLogs,
        copyYear,
        fetchAccountCategories,
        deleteAccountCategory,
        createAccountCategory,
        updateAccountCategory,
        fetchVATCodes,
        deleteVATCode,
        createVATCode,
        updateVATCode,
        deleteRegion,
        createRegion,
        updateRegion,
        fetchFinancialYears,
        deleteFinancialYear,
        createFinancialYear,
        updateFinancialYear,

        downloadBranchSummary,
        downloadBankAccountBalances,
        downloadOverDueYearEndFiling,
        downloadYearEndSignOff,

        unlockUser,
        checkUserLocked,
        resetUser,
        checkUserReset,
        uploadLogo,
        removeLogo,
        uploadFestivalLogo,
        removeFestivalLogo,
    };
};